/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'redux';
import { AxiosResponse } from "axios";
import { 
    // MultiRecordResponse, 
    ThunkResult } from "./actionResultTypes";
import { 
    Action,
    ActionType, 
    IFetchContracts,
    IFetchContractsSuccess,
    IFetchContractsFail,
    ISelectedCurrentContract,
    IFetchContractChanges,
    IFetchContractChangesSuccess,
    IFetchContractChangesFail,
} from "../actionTypes/contractActionTypes";
import { toastError } from '../../services/toasters';
import { 
    IContract as Contract,
    IContractConfirmers,
} from '../../models/contract';
import { MultiResponseType } from '../../models/multiResponseType'
import { httpGenerator } from '../../services';
import { IRequestContractChange } from '../../models/permission';
import { SingleResponseType } from '../../models/singleResponseType';


export const GetContracts = (userid: number | undefined): ThunkResult<void> => async (dispatch: Dispatch<Action>) => { 
    dispatch<IFetchContracts>({  
        type: ActionType.FETCH_CONTRACTS 
    });
    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<MultiResponseType<Contract>> = await httpGenerator(authToken!).get(`contracts/${userid}`);
        dispatch<IFetchContractsSuccess>({
            type: ActionType.FETCH_CONTRACTS_SUCCESS,
            payload: response.data
        });

    } catch(err: any) {
        dispatch<IFetchContractsFail>({
            type: ActionType.FETCH_CONTRACTS_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در بازیابی اطلاعات");
    }
}

export const SetContractChange = (contractid: number, request: IRequestContractChange): ThunkResult<void> => async (dispatch: Dispatch<Action>) => { 
    dispatch<IFetchContractChanges>({  
        type: ActionType.FETCH_CONTRACTCHANGES 
    });
    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<SingleResponseType<IContractConfirmers>> = await httpGenerator(authToken!).get(`contractConfirmers/${contractid}`);
        dispatch<IFetchContractChangesSuccess>({
            type: ActionType.FETCH_CONTRACTCHANGES_SUCCESS,
            payload: response.data,
            offline_payload: request
        });
        // console.log( "------- action response.data: ",  response.data)
    } catch(err: any) {
        dispatch<IFetchContractChangesFail>({
            type: ActionType.FETCH_CONTRACTCHANGES_FAIL,
            payload: err
        });
        console.log('err: ', err)
        toastError("خطا در ذخیره سازی اطلاعات جدید");
    }
}

export const SetCurrentContract = (request: IRequestContractChange) => {
    // console.log('*** Action SetCurrentContract()')
    return (dispatch: Dispatch<Action>)=> {
        dispatch<ISelectedCurrentContract>({ 
            type: ActionType.SELECTED_CURRENT_CONTRACT,
            payload: request, 
        });
    }
}